import React from 'react';
import { Card, CardContent, Skeleton, Stack, Box } from '@mui/material';

interface MobileCardSkeletonProps {
  count?: number;
}

const MobileCardSkeleton: React.FC<MobileCardSkeletonProps> = ({ count = 5 }) => {
  return (
    <Stack spacing={2}>
      {Array.from({ length: count }).map((_, index) => (
        <Card 
          key={index}
          sx={{ 
            boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.05)',
            borderRadius: 2,
            overflow: 'hidden'
          }}
        >
          <CardContent sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Skeleton 
                variant="circular" 
                width={40} 
                height={40} 
                sx={{ mr: 2 }}
                animation="wave"
              />
              <Box sx={{ flex: 1 }}>
                <Skeleton 
                  variant="text" 
                  width="60%" 
                  height={24} 
                  sx={{ borderRadius: 0.5 }}
                  animation="wave"
                />
                <Skeleton 
                  variant="text" 
                  width="40%" 
                  height={18} 
                  sx={{ borderRadius: 0.5, mt: 0.5 }}
                  animation="wave"
                />
              </Box>
            </Box>
            
            <Stack spacing={1}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton 
                  variant="text" 
                  width="30%" 
                  height={16} 
                  sx={{ borderRadius: 0.5 }}
                  animation="wave"
                />
                <Skeleton 
                  variant="text" 
                  width="40%" 
                  height={16} 
                  sx={{ borderRadius: 0.5 }}
                  animation="wave"
                />
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton 
                  variant="text" 
                  width="35%" 
                  height={16} 
                  sx={{ borderRadius: 0.5 }}
                  animation="wave"
                />
                <Skeleton 
                  variant="text" 
                  width="30%" 
                  height={16} 
                  sx={{ borderRadius: 0.5 }}
                  animation="wave"
                />
              </Box>
            </Stack>
            
            <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
              <Skeleton 
                variant="rectangular" 
                width="48%" 
                height={36} 
                sx={{ borderRadius: 1 }}
                animation="wave"
              />
              <Skeleton 
                variant="rectangular" 
                width="48%" 
                height={36} 
                sx={{ borderRadius: 1 }}
                animation="wave"
              />
            </Box>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export default MobileCardSkeleton;